import { NavigationState } from 'element-domain/src/__generated/application-types'
import type { $Table } from 'element-domain/src/__generated/enhanced-model'

import { CustomFinalizeButton } from '@salsita-ai/platform-project-sdk/configurator'

import { configuratorInterface } from '../../../systems/configurator-interface'
import { RequestQuoteButton } from './RequestQuoteButton'

const PERSONALIZED_QUOTE_VIOLATIONS = new Set([
  'lengthMightNotBeAvailableForThisTop',
  'thicknessTypeMightNotBeAvailableForThisTop',
  'customTopFinishNeedsPersonalizedQuote',
  'customLeafSizeNeedsPersonalizedQuote',
  'customBaseFinishNeedsPersonalizedQuote',
])

const CustomSummaryFooter: React.FC<{ table: $Table }> = ({ table }) => {
  const { navigationSystem, storeSystem } = configuratorInterface.useDomain()

  // Warnings and personalized-quote notices cannot be bought through Shopify.
  // Quote-only violations are notices so the quote finalization webhook will accept them.
  const cartBlockingViolations = [...table.$violations, ...table.$top.$violations, ...table.$base.$violations].filter(
    violation => violation.severity === 'warning' || PERSONALIZED_QUOTE_VIOLATIONS.has(violation.type)
  )

  const cannotBeBought = cartBlockingViolations.length > 0

  const hint =
    cartBlockingViolations.length > 0
      ? 'Cannot be bought because of the following:\n' +
        cartBlockingViolations
          .map(v => {
            if (typeof v.message === 'string') {
              return v.message
            } else if (v.message && typeof v.message === 'object' && 'message' in v.message) {
              return v.message.message
            } else if (v.message && typeof v.message === 'object' && '$lang' in v.message) {
              return v.message.$lang['en'] ?? Object.values(v.message.$lang)[0] ?? ''
            }
            return ''
          })
          .join(', ') +
        '.'
      : ''

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', gap: 10, justifyContent: 'center', width: '100%' }}>
        <RequestQuoteButton title="Request Quote" table={table} style={{ flex: 1, width: '100%' }} />

        <div style={{ flex: 1, width: '100%' }}>
          <CustomFinalizeButton
            title="ADD TO CART"
            disabled={cannotBeBought}
            hints={hint}
            onClick={() => {
              storeSystem.stageAndCommit([
                navigationSystem.getPushNavigationUpdate(
                  NavigationState.FinalizeCart,
                  storeSystem.stateSlices.committed.value.state
                ),
              ])
            }}
          />
        </div>
      </div>
    </>
  )
}

export default CustomSummaryFooter
